@if (validationContext) {
<form [formGroup]="form">
    <rask-page [pageTitle]="title">
        <ng-container header>
            @if (!isNew()) {
            <rask-action-button
                (click)="delete()"
                [disabled]="!canDelete()"
                icon="far fa-trash-alt"
                aid="delete">
                Ta bort
            </rask-action-button>
            }
            @if (!isNew()) {
            <rask-menu-button label="Hantera" alignment="right" icon="fa-solid fa-chevron-down" [template]="tpl" #menu>
            </rask-menu-button>
            }
        </ng-container>
        <rask-produktinstruktioner-details-header
            [viewModel]="selectedProduktdefinition"
            [validationContext]="validationContext"
            [rootForm]="form"
            [basData]="produktinstruktionBasdata"></rask-produktinstruktioner-details-header>
        <rask-container-block>
            <rask-tabs parameterName="tab" aid="produktinstruktiontabs" layout="child">
                <rask-tab label="Grunddata" routeId="grunddata" aid="grunddata">
                    <ng-template #tabContent>
                        <rask-grunddata
                            [viewModel]="selectedProduktdefinition"
                            [rootForm]="form"
                            [validationContext]="validationContext"
                            [basData]="produktinstruktionBasdata">
                        </rask-grunddata>
                    </ng-template>
                </rask-tab>
                <rask-tab label="Värdematris" routeId="vardematris" aid="vardematris">
                    <ng-template #tabContent>
                        <rask-vardematris
                            #vardematris
                            [viewModel]="selectedProduktdefinition"
                            [basData]="produktinstruktionBasdata"
                            [rootForm]="form">
                        </rask-vardematris>
                    </ng-template>
                </rask-tab>
                <rask-tab label="Fördelningsmatris" routeId="fordelningsmatris" aid="fordelningsmatris">
                    <ng-template #tabContent>
                        <rask-fordelningsmatris
                            #fordelningsmatris
                            [viewModel]="selectedProduktdefinition"
                            [rootForm]="form"
                            [basData]="produktinstruktionBasdata">
                        </rask-fordelningsmatris>
                    </ng-template>
                </rask-tab>
                <rask-tab label="Begränsning" routeId="begransning" aid="begransning">
                    <ng-template #tabContent>
                        <rask-begransningsmatris
                            #begransning
                            [viewModel]="selectedProduktdefinition"
                            [rootForm]="form">
                        </rask-begransningsmatris>
                    </ng-template>
                </rask-tab>
                <rask-tab label="Färgmärkning" routeId="fargmarkning" aid="fargmarkning">
                    <ng-template #tabContent>
                        <rask-fargmarkning
                            #fargmarkning
                            [viewModel]="selectedProduktdefinition"
                            [rootForm]="form">
                        </rask-fargmarkning>
                    </ng-template>
                </rask-tab>
                <rask-tab label="Stolp" routeId="stolp" aid="stolp">
                    <ng-template #tabContent>
                        <rask-stolp
                            #stolp
                            [viewModel]="selectedProduktdefinition"
                            [validationContext]="validationContext"
                            [rootForm]="form">
                        </rask-stolp>
                    </ng-template>
                </rask-tab>
                <rask-tab label="Restriktioner" routeId="restriktioner" aid="restriktioner">
                    <ng-template #tabContent>
                        <rask-restriktioner
                            [viewModel]="selectedProduktdefinition"
                            [rootForm]="form">
                        </rask-restriktioner>
                    </ng-template>
                </rask-tab>
            </rask-tabs>
        </rask-container-block>
        <ng-container footerContent>
            @if (!isNew()) {
            <rask-button color="secondary" (click)="downloadPin()"><span class="fas fa-download"></span>
                PIN</rask-button>
            }
            <rask-save-button aid="save" (click)="save()" [disabled]="!canSave()"></rask-save-button>
        </ng-container>
    </rask-page>
</form>
}
<ng-template #tpl>
    <div class="menu-btn-container">
        @if (selectedProduktdefinition.isUtkast || selectedProduktdefinition.isHistorisk) {
        <rask-action-button
            class="col-12"
            aid="buttonLrVisaPublicerad"
            (click)="hamtaPublicerad()"
            [disabled]="!canVisaPublicerad()">Visa publicerad</rask-action-button>
        }
        @if (selectedProduktdefinition.isUtkast) {
        <rask-action-button
            class="col-12"
            aid="buttonLrDiscard"
            (click)="discardDraft()"
            [disabled]="!canDiscardDraft()">Ångra utkast</rask-action-button>
        }
        @if (selectedProduktdefinition.isUtkast) {
        <rask-action-button
            class="col-12"
            aid="buttonLrPublicera"
            [disabled]="!canPublicera()"
            (click)="publicera()">Publicera</rask-action-button>
        }
        @if ((!selectedProduktdefinition.isUtkast && !produktinstruktion.utkastProduktdefinition) ||
        selectedProduktdefinition.isHistorisk) {
        <rask-action-button
            class="col-12"
            aid="buttonLrSkapaUtkast"
            [disabled]="!canSkapaUtkast()"
            (click)="skapaUtkast()">Skapa utkast</rask-action-button>
        }
        @if (!selectedProduktdefinition.isUtkast && produktinstruktion.utkastProduktdefinition) {
        <rask-action-button
            class="col-12"
            aid="buttonLrVisaUtkast"
            (click)="hamtaUtkast()"
            [disabled]="!canVisaUtkast()">Visa utkast</rask-action-button>
        }
        @if (!selectedProduktdefinition.isHistorisk) {
        <rask-action-button
            class="col-12"
            aid="buttonLrInaktivera"
            (click)="inaktivera()"
            [disabled]="!canInaktivera()  && !selectedProduktdefinition.isHistorisk">Inaktivera</rask-action-button>
        }
        @if (!selectedProduktdefinition.isHistorisk) {
        <rask-action-button
            class="col-12"
            aid="buttonLrAktivera"
            (click)="aktivera()"
            [disabled]="!canAktivera()">Aktivera
        </rask-action-button>
        }
        @if (!selectedProduktdefinition.isUtkast && !selectedProduktdefinition.isHistorisk) {
        <rask-action-button
            class="col-12"
            aid="buttonLrKopiera"
            (click)="skapaKopia()"
            [disabled]="!canSkapaKopia()">Skapa kopia
        </rask-action-button>
        }
        @if (!selectedProduktdefinition.isUtkast) {
        <rask-action-button
            class="col-12"
            aid="buttonLrHistorik"
            (click)="visaHistorik()">Se tidigare versioner
        </rask-action-button>
        }
    </div>
</ng-template>